import { styled } from '@/styled-system/jsx';

// HdpSummaryAddress styles
export const StyledHdpAddressDisplayName = styled('h1', {
  base: {
    color: 'hpxBlue600',
    fontWeight: 'bold',
    marginTop: '16px',
    marginBottom: '8px',
    fontSize: '22px',
    lineHeight: '24px',
    md: {
      fontSize: '28px',
      lineHeight: '24px',
    },
  },
});

export const StyledHdpAddressDisplayWrapper = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
});

export const StyledHdpAddressDisplayAddress = styled('h2', {
  base: {
    color: 'hpxGrey500',
  },
});

// HdpSummaryListingTags styles
export const StyledListingRestrictionTag = styled('span', {
  base: {
    display: 'inline-block',
    background: 'hpxTeal100',
    color: 'hpxBlue500',
    fontSize: 'sm',
    paddingTop: '4px',
    paddingBottom: '4px',
    paddingLeft: '16px',
    paddingRight: '16px',
    borderRadius: '16px',
    verticalAlign: 'bottom',
    marginRight: '8px',
  },
});

export const StyledListingTagWrapper = styled('div', {
  base: {
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderBottomColor: 'hpxGrey100',
  },
});

// HdpEmergencyBanner styles
export const StyledEmergencyBanner = styled('div', {
  base: {
    borderWidth: '0.5px',
    borderStyle: 'solid',
    borderColor: '#33a592',
    borderRadius: '4px',
    backgroundColor: 'hpxTeal100',
    marginBottom: '16px',
    paddingTop: '8px',
    paddingBottom: '8px',
    paddingLeft: '8px',
    paddingRight: '8px',
    width: '100%',
  },
});

export const StyledBannerContent = styled('div', {
  base: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '8px',
  },
});

export const StyledAlertImage = styled('img', {
  base: {
    flexShrink: 0,
  },
});

export const StyledBannerText = styled('div', {
  base: {
    flex: '1',
    lineHeight: '24px',
  },
});

// HdpSummaryDetails styles
export const StyledDetailedRow = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginTop: '0px',
    marginRight: '0px',
    marginBottom: '16px',
    marginLeft: '0px',
    gap: '24px',
  },
  variants: {
    isRoomForRent: {
      true: {
        alignItems: 'flex-start',
      },
    },
  },
});

export const StyledDetailItem = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: '4px',
  },
});

export const StyledDetailValue = styled('div', {
  base: {
    fontWeight: '600',
    color: 'hpxBlue600',
  },
});

export const StyledDetailLabel = styled('div', {
  base: {
    color: 'hpxGrey500',
    fontWeight: '400',
  },
});

export const StyledPriceRow = styled('div', {
  base: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    paddingTop: '16px',
  },
});
